<template>
  <div class="container-fluid">
    <div class="spinner-container" v-if="loading == 1">
      <div id="loader"></div>
    </div>
    <div class="row">
      <div
        class="col-lg-2 col-md-2"
        style="paddingLeft: 0px; paddingRight: 0px"
      >
        <Sidebar></Sidebar>
      </div>
      <div class="col-lg-10 col-md-10 col-12 mt-2 dev animate-bottom">
        <div class="row pt-3">
          <div class="col h4 text-center">
            {{ this.company }}
          </div>
        </div>
        <div class="row count-row mt-2">
          <div class="col form-check text-left">
            <input
              v-model="deviceType"
              @click="custClick"
              class="form-check-input"
              type="radio"
              name="deviceCount"
              id="allDevices"
              value="allDev"
            />
            <span class="badge badge-info">All Devices</span>
            <small style="color: black">{{ onlineCount + offlineCount }}</small>
          </div>
          <div class="col form-check text-center">
            <input
              v-model="deviceType"
              @click="custClick"
              class="form-check-input"
              type="radio"
              name="deviceCount"
              id="onDevices"
              value="onDev"
              checked
            />
            <span class="badge badge-success">Online</span>
            <small style="color: black">{{ onlineCount }}</small>
          </div>
          <div class="col form-check text-right">
            <input
              v-model="deviceType"
              @click="custClick"
              class="form-check-input"
              type="radio"
              name="deviceCount"
              id="offDevices"
              value="offDev"
            />
            <span class="badge badge-danger">Offline</span>
            <small style="color: black">{{ offlineCount }}</small>
          </div>
        </div>

        <div class="row srchfilter mt-3">
          <div class="col-lg-3 col-md-3 col-2 searchbar">
            <input
              class="mt-1 form-control"
              type="search"
              id="site-search"
              name="q"
              aria-label="Search through site content"
              placeholder="Search devices"
              v-model="search"
              @keyup="currentSearch"
            />
          </div>
        </div>
        <div class="row" style="height: inherit; width: inherit">
          <div
            class="col-lg-12 listofdev border"
            style="height: 72vh; overflow-y: auto"
          >
            <table class="table table-list border dev-table">
              <thead class="table ubuntu-medium">
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">Device Id</th>
                  <th scope="col">Device Type</th>
                  <th scope="col">Gas Sensor</th>
                  <th scope="col">Last Online</th>
                  <th scope="col" v-if="roleId == 3">
                    <i class="fas fa-edit"></i>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="devices in filteredAndSorted"
                  v-bind:key="devices._id"
                  class="ubuntu-medium"
                >
                  <td>
                    <p class="name p-0">
                      <a
                        :href="'#/device/' + devices.devId + '/info'"
                        target="_blank"
                      >
                        <span
                          class="cursor-pointer"
                          data-toggle="tooltip"
                          title="Click for details"
                          >{{ devices.name }}</span
                        >
                      </a>
                    </p>
                  </td>
                  <td>
                    <p class="p-0">
                      <a
                        :href="'#/device/' + devices.devId + '/info'"
                        target="_blank"
                      >
                        <span
                          class="devId cursor-pointer"
                          data-toggle="tooltip"
                          title="Click for details"
                          >{{ devices.devId }}</span
                        >
                      </a>
                    </p>
                  </td>
                  <td>{{ devices.deviceType || "na" }}</td>
                  <td>{{ devices.gasSensor }}</td>
                  <td>{{ devices.lastOnline }}</td>
                  <td v-if="roleId == 3">
                    <i
                      @click="routeToUpdate(devices)"
                      class="fas fa-pen"
                      style="cursor: pointer"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal fade bd-example-modal-lg"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
    >
      <div class="modal-dialog modal-sm">
        <div class="modal-content" style="width: 48px">
          <span class="fa fa-spinner fa-spin fa-3x"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiCall } from "@/utils/api";
import Sidebar from "./Sidebar";
// import _ from 'underscore';

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      loading: 0,
      customers: [],
      totalDevices: [],
      onlineCount: 0,
      offlineCount: 0,
      devices: [],
      sortKey: "",
      search: "",
      reverse: false,
      custKey: this.$route.params.custId,
      company: this.$route.params.company,
      deviceType: "onDev",
      autoRefresh: 0,
      roleId: parseInt(JSON.parse(localStorage.getItem("user")).roleId),
    };
  },
  mounted() {
    this.custClick();
    // setInterval(() => {
    //   this.autoRefresh = 1;
    //   this.custClick();
    //   },6000,
    // );
  },
  computed: {
    // filteredUsers() {
    //   return this.devices.filter((device) => {
    //     return device.name.toLowerCase().includes(this.search.toLowerCase());
    //   });
    // },
    filteredAndSorted() {
      function compare(a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      }
      if (this.devices)
        return this.devices
          .filter((device) => {
            if (device.name) {
              return (
                (device.name
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) ||
                  device.devId
                    .toLowerCase()
                    .includes(this.search.toLowerCase())) &&
                (this.deviceType === "allDev"
                  ? true
                  : this.deviceType === "onDev" && device.onlineStatus === true
                  ? true
                  : this.deviceType === "offDev" &&
                    device.onlineStatus === false
                  ? true
                  : false)
              );
            } else {
              return (
                device.devId
                  .toLowerCase()
                  .includes(this.search.toLowerCase()) &&
                (this.deviceType === "allDev"
                  ? true
                  : this.deviceType === "onDev" && device.onlineStatus === true
                  ? true
                  : this.deviceType === "offDev" &&
                    device.onlineStatus === false
                  ? true
                  : false)
              );
            }
          })
          .sort(compare);
    },
  },
  methods: {
    custClick() {
      // if (this.autoRefresh !== 1) {
      //   this.loading = 1;
      // }
      if (this.custKey) {
        const baseURI = `device/by-customer/${this.custKey}`;
        apiCall({ url: baseURI, method: "get" }).then((result) => {
          this.onlineCount = result.onlineCount;
          this.offlineCount = result.offlineCount;
          this.devices = result.devices;
          this.loading = 0;
        });
      }
    },
    currentSearch() {
      // console.log('user searched', this.search);
      // console.log('filtered', this.devices.filter((elm) => elm.includes(this.search)) )
    },
    routeToUpdate(id) {
      // console.log("clicked id", id);
      this.$router.push(`/updateDevice/${id.devId}`);
    },
  },
};
</script>
<style>
.container-fluid {
  margin: 0px;
  padding: 0px;
}
.ubuntu-small {
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.ubuntu-medium {
  font-family: Ubuntu;
  font-weight: 500;
  font-size: 14px;
  color: rgba(59, 59, 59, 0.8);
}
.dev {
  font-family: Ubuntu;
  font-weight: 200;
  color: rgba(59, 59, 59, 0.8);
  padding-left: 3.5rem !important;
  padding-right: 2.2rem !important;
}
a {
  /* color: rgba(59, 59, 59, 0.8); */
  text-decoration: none;
}
.btn:focus {
  box-shadow: none;
}
.form-control {
  color: rgba(59, 59, 59, 0.8);
  font-family: Ubuntu;
  font-weight: 200;
  font-size: 13px;
  height: 2rem !important;
}
.option:hover {
  color: #2295c8;
  background-color: transparent;
}
.form-control:focus {
  box-shadow: none;
  border: none;
}
.option:focus {
  background-color: transparent;
  border: none;
}
.form-check-input {
  margin-top: 0.7rem;
}
.listofdev {
  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.2);
  border-top: none !important;
  padding-left: 0px;
  padding-right: 0px;
  border-bottom-left-radius: 0.63rem;
  border-bottom-right-radius: 0.63rem;
}
.srchfilter {
  border-bottom: none !important;
  /* background-color: #2295c8; */
  background-color: rgba(0, 0, 0, 0.1);
  width: 100%;
  border: 1px solid #dedede;
  padding-top: 5px;
  padding-bottom: 5px;
}
a:link {
  text-decoration: none;
}
a {
  color: rgba(59, 59, 59, 0.8);
}
a:hover {
  color: #2295c8;
}
.bd-example-modal-lg .modal-dialog {
  display: table;
  position: relative;
  margin: 0 auto;
  top: calc(50% - 24px);
}

.bd-example-modal-lg .modal-dialog .modal-content {
  background-color: transparent;
  border: none;
}

.model {
  display: block;
}

.count-row {
  font-size: 20px;
}
.back {
  cursor: pointer;
}
#loader {
  position: absolute;
  left: 50%;
  top: 50%;
  z-index: 1;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.6;
  z-index: 1;
  margin: -15px;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Add animation to 'page content' */
.animate-bottom {
  position: relative;
  -webkit-animation-name: animatebottom;
  -webkit-animation-duration: 1s;
  animation-name: animatebottom;
  animation-duration: 1s;
}

@-webkit-keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0px;
    opacity: 1;
  }
}

@keyframes animatebottom {
  from {
    bottom: -100px;
    opacity: 0;
  }
  to {
    bottom: 0;
    opacity: 1;
  }
}
</style>
